import { selectSharedDataActiveTimelineChronologyType, TimelineChronologyType, useAppSelector } from '@/store';

export const Label = () => {
  const activeTimelineChronologyType = useAppSelector(selectSharedDataActiveTimelineChronologyType);

  return (
    <>
      {activeTimelineChronologyType === TimelineChronologyType.TIMELINE && (
        <span className="text-[20px] font-semibold whitespace-nowrap">Timeline</span>
      )}
      {activeTimelineChronologyType === TimelineChronologyType.CHRONOLOGY && (
        <span className="text-[20px] font-semibold whitespace-nowrap">Chronology</span>
      )}
    </>
  );
};
